var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionnaireActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_33450",
    "data-name": "Group 33450",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.809,
    height: 18,
    viewBox: "0 0 17.809 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9755",
    "data-name": "Rectangle 9755",
    width: 17.809,
    height: 18,
    fill: "#4b74be"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33450-2",
    "data-name": "Group 33450",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70471",
    "data-name": "Path 70471",
    d: "M7.928,15.561v2.125h2.086l6.045-6.216L13.97,9.342Zm9.722-6.5-1.256-1.28a.527.527,0,0,0-.772,0l-.99,1.009,2.086,2.128.929-1.069A.563.563,0,0,0,17.65,9.063Z",
    fill: "#4b74be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70472",
    "data-name": "Path 70472",
    d: "M6.148,16.4H2.487A.983.983,0,0,1,1.536,15.4V2.605A.983.983,0,0,1,2.487,1.6H13.938a.983.983,0,0,1,.951,1.009V5.861a.77.77,0,1,0,1.538,0V2.605A2.552,2.552,0,0,0,13.941,0H2.487A2.551,2.551,0,0,0,0,2.605V15.4A2.549,2.549,0,0,0,2.487,18H6.148a.8.8,0,0,0,0-1.6",
    fill: "#4b74be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70473",
    "data-name": "Path 70473",
    d: "M13.059,4.525a.785.785,0,0,0-.769-.8H4.054a.8.8,0,0,0,0,1.6H12.29A.785.785,0,0,0,13.059,4.525ZM7.281,10.359H4.054a.8.8,0,0,0,0,1.6H7.281a.8.8,0,0,0,0-1.6M4.054,6.932a.8.8,0,0,0,0,1.6H9.738a.8.8,0,0,0,0-1.6Z",
    fill: "#4b74be"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaireActive);
export default __webpack_public_path__ + "static/media/QuestionnaireActive.f8f1093d94878067744c4768fff4ae03.svg";
export { ForwardRef as ReactComponent };